import {
  useStoreActions,
  useReducerData,
  useReducerLoading,
} from 'store/hooks';

import { REDUCER_NAMES, REDUCER_ATTRIBUTES } from 'helper/store';
import * as recurringRulesSelectors from 'store/selectors/recurringRules';
import * as recurringRulesActions from 'store/actions/recurringRules';
import * as orderTypeActions from 'store/actions/orderType';

export const useIndexData = () => {
  return {
    recurringRules: recurringRulesSelectors.useSelectRecurringRules(),
    recurringRulesLoading: recurringRulesSelectors.useSelectRecurringRulesLoading(),
    deleteRecurringRuleLoading: recurringRulesSelectors.useSelectDeleteRecurringRuleLoading(),
    createRecurringRuleLoading: recurringRulesSelectors.useSelectCreateRecurringRuleLoading(),
    updateRecurringRuleLoading: recurringRulesSelectors.useSelectUpdateRecurringRuleLoading(),
    orderTypes: useReducerData(
      REDUCER_NAMES.ORDER_TYPE,
      REDUCER_ATTRIBUTES.ORDER_TYPE.ALL_ORDER_TYPE_LIST,
      []
    ),
    orderTypesLoading: useReducerLoading(
      REDUCER_NAMES.ORDER_TYPE,
      REDUCER_ATTRIBUTES.ORDER_TYPE.ALL_ORDER_TYPE_LIST
    ),
  };
};

export const useActions = () => {
  return useStoreActions({
    ...recurringRulesActions,
    ...orderTypeActions,
  });
};
